import React from 'react';
import { BsWindow } from 'react-icons/bs';

import BaseEditWidget from '../BaseEditWidget';
import '../../EditWidget/EditWidget.scss';

const EditLandingPages = (props: any) => {
	return (
		<BaseEditWidget
			{...props}
			defaultIcon={{
				name: 'BsWindow',
				label: 'window',
				component: BsWindow,
			}}
			defaultTheme="purple"
			widgetType="landingPages"
		/>
	);
};

export default EditLandingPages;
